import { showCalendarItem, showCustomCalendarItem } from "#scripts/calendar.js";
import breadcrumb from "#templates/pages/breadcrumb";
import language from "#scripts/translation";
// import "#npm/@prokomssp/fantdu/dist/fantdu.min.js";
import "../../../node_modules/@prokomssp/fantdu/dist/fantdu.min.js";

const fantduCss = `
  #feedback {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .fant-du__heading {
      font-size: var(--fantdu__heading_font-size, 1.5rem);
      font-weight: var(--fantdu__heading_font-weight, bold);
  }
  button.fant-du__button--yes {
      border-color: var(--fantdu__button__yes__border-color, var(--fantdu__button__border-color, var(--primary__color)));border-radius: var(--fantdu__button__border-radius, 0);;
  }
  button.fant-du__button--no {
      border-color: var(--fantdu__button__no__border-color, var(--fantdu__button__border-color, var(--primary__color)));border-radius: var(--fantdu__button__border-radius, 0);;
  }
  input.fant-du__input,
  textarea.fant-du__textarea {
    background-color: #ffffff;
    min-width: 303px;
  }
  .fant-du__textarea:focus {
    box-shadow: 0 0 0 3px #385dff;
    outline: none;
  }
`;

export const event = () => {
	showCalendarItem();
	const breadcrumbHtml = breadcrumb();
	const nameId = window.serverdata.configMeta.aim.nameId || "";

	const askForEmail = window.serverdata.configMeta.aim?.fantduAskForEmail ? 'ask-for-email="true"' : "";

	return `
        <div class="container p-md-0">
            ${breadcrumbHtml}
        </div>
        <div class="container p-md-0">
            <div class="row">
                <div class="col-12">
                    <div class="calendar__event__container">
                        <div class="spinner-border align-self-center" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        ${
					window.serverdata.configMeta.aim?.doNotUseFantdu
						? ""
						: `
        <div class="fant_du_container">
            <fant-du client="${nameId}" ${askForEmail} 
                title-text="${language("FANTDU_TITLE")}" 
                second-title-text="${language("FANTDU_TITLE2")}" 
                placeholder-text="${language("FANTDU_PLACEHOLDER")}" 
                email-invitation-text="${language("FANTDU_EMAIL_PLACEHOLDER")}" 
                send-in-text="${language("FANTDU_SEND_BUTTON")}" 
                yes-text="${language("FANTDU_YES")}" 
                no-text="${language("FANTDU_NO")}" 
                pre-textarea-text="${language("FANTDU_PRETEXT")}" 
                post-message="${language("FANTDU_POSTTEXT")}"
                receipt-text-content="${language("FANTDU_EYOK")}"
                onSubmitSuccess="fantdu__success" onSubmitFail="fandu__failed" css="${fantduCss}"></fant-du> 
        </div>`
				}
    `;
};

export const eventCustom = () => {
	showCustomCalendarItem();
	const breadcrumbHtml = breadcrumb();
	const nameId = window.serverdata.configMeta.aim.nameId || "";
	const askForEmail = window.serverdata.configMeta.aim?.fantduAskForEmail ? 'ask-for-email="true"' : "";

	return `
        <div class="container p-md-0">
            ${breadcrumbHtml}
        </div>
        <div class="container p-md-0">
            <div class="row">
                <div class="col-12">
                    <div class="calendar__event__container">
                        <div class="spinner-border align-self-center" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        ${
					window.serverdata.configMeta.aim?.doNotUseFantdu
						? ""
						: `
        <div class="fant_du_container"> 
            <fant-du client="${nameId}" ${askForEmail} 
                title-text="${language("FANTDU_TITLE")}" 
                second-title-text="${language("FANTDU_TITLE2")}" 
                placeholder-text="${language("FANTDU_PLACEHOLDER")}" 
                email-invitation-text="${language("FANTDU_EMAIL_PLACEHOLDER")}" 
                send-in-text="${language("FANTDU_SEND_BUTTON")}" 
                yes-text="${language("FANTDU_YES")}" 
                no-text="${language("FANTDU_NO")}" 
                pre-textarea-text="${language("FANTDU_PRETEXT")}" 
                post-message="${language("FANTDU_POSTTEXT")}"
                receipt-text-content="${language("FANTDU_EYOK")}"
                onSubmitSuccess="fantdu__success" onSubmitFail="fandu__failed" css="${fantduCss}"></fant-du>
        </div>`
				}
    `;
};
